export default "__VITE_ASSET__765043aa__"